import { render, staticRenderFns } from "./MusicPlayed.vue?vue&type=template&id=df7beffe&scoped=true"
import script from "./MusicPlayed.vue?vue&type=script&lang=js"
export * from "./MusicPlayed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7beffe",
  null
  
)

export default component.exports